import React from "react";
import classes1 from ".././Indent.module.css";

const StatusBadge = ({ status, type }) => {
  const isPmIndent = type === "private_market_place_indent" ? true : false;

  const getIndentStatus = () => {
    // Map of status types to their respective icons and text
    const statusMap = {
      pending: { iconClass: "far fa-clock", text: "Pending" },
      accepted: { iconClass: "far fa-check-circle", text: "Accepted" },
      rejected: { iconClass: "far fa-times-circle", text: "Rejected" },
      marketplace: { iconClass: "fa fa-cart-arrow-down", text: "Marketplace" },
      allocated: { iconClass: "fas fa-truck", text: "Allocated" },
      "not allocated": { iconClass: "fas fa-truck", text: "Not Allocated" },
    };
  
    // Determine icon and text based on whether it's a marketplace indent
    const { iconClass, text } = isPmIndent
      ? statusMap["marketplace"]
      : statusMap[status] || {
          iconClass: "far fa-clock", // Default icon
          text: "Pending",           // Default text
        };
  
    // Render the status with icon and text
    return (
      <div className="d-flex align-items-center" style={{ gap: "5px" }}>
        <i
          className={iconClass}
          style={{ fontSize: "12px", cursor: "default" }}
        ></i>
        <span>{text}</span>
      </div>
    );
  };
  

  //get the classes for the respective status
  const getStatusClassName = () => {
    if (isPmIndent) {
      return classes1["marketplace"];
    }

    switch (status) {
      case "pending":
        return classes1["pending"];
      case "accepted":
        return classes1["accepted"];
      case "allocated":
        return classes1["accepted"];
      case "not allocated":
        return classes1["not_allocated"];
      case "rejected":
        return classes1["rejected"];
      case "marketplace":
        return classes1["marketplace"];
      default:
        return classes1["pending"];
    }
  };

  return (
    <div className={`${classes1["status_badge"]} ${getStatusClassName()}`}>
      {getIndentStatus()}
    </div>
  );
};

export default StatusBadge;
